"use strict";

module.exports = function (array) {
	return array.slice(0);
};